import Vue from 'vue'
import VueRouter from 'vue-router'
// https://github.com/declandewet/vue-meta
import VueMeta from 'vue-meta'
// Adds a loading bar at the top during page loads.
import NProgress from 'nprogress/nprogress'
import store from '@state/store'
import routes from './routes'

// dialog
import VuejsDialog from 'vuejs-dialog'
// import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components

// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

// Tell Vue to install the plugin.
Vue.use(VuejsDialog)
// dialog

Vue.use(VueRouter)
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page',
})

Vue.filter('toCurrency', function(value) {
  if (typeof value !== 'number') {
    return value
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  })
  return formatter.format(value)
})

const router = new VueRouter({
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  // If this isn't an initial page load...
  if (routeFrom.name !== null) {
    // Start the route progress bar.
    document.body.style.overflowY = 'hidden'
    NProgress.start()
  }

  // Check if auth is required on this route
  // (including nested routes).
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired)

  // If auth isn't required for the route, just continue.
  if (!authRequired) return next()

  // If auth is required and the user is logged in...
  if (store.getters['auth/loggedIn']) {
    // Validate the local user token...
    return store
      .dispatch('auth/validate')
      .then((validUser) => {
        // Then continue if the token still represents a valid user,
        // otherwise redirect to login.
        validUser = true
        if (validUser) {
          if (
            store.getters['auth/hasPriv'](routeTo.meta.priv) ||
            typeof routeTo.meta.priv === 'undefined'
          ) {
            let routeHasHoldAction = [
              'form-daily-drilling-report',
              'form-drilling-activity-kick',
              'form-drilling-activity-casing',
              'form-drilling-activity-cement',
              'form-drilling-activity-coring',
              'form-drilling-activity-logging',
              'form-drilling-activity-fishing',
              'form-drilling-activity-well-test',
              'form-drilling-activity-general-work',
              'subsurface-form',
            ]

            if (
              routeHasHoldAction.find(function(element) {
                return element === routeFrom.name
              })
            ) {
              NProgress.done()
              Vue.dialog
                .confirm(
                  'You are in form input activity. Make sure your data saved when you are leave from current input activity.'
                )
                .then(function(dialog) {
                  next()
                  NProgress.done()
                })
                .catch(function() {
                  NProgress.start()
                  next({ name: routeFrom.name })
                  NProgress.done()
                  NProgress.done()
                })
            } else {
              // Continue to the login page
              next()
              NProgress.done()
            }

            // routeHasHoldAction.forEach((item)=>{

            // })

            // if (routeFrom.name === 'form-daily-drilling-report' && store.getters['form/dailyDrillingReport'].length > 0) {
            //   if (store.getters['form/dailyDrillingReport'].length > 0) {
            //     let r = confirm("You are in form input activity. Make sure your data saved when you are leave from current input activity.");
            //     if (r === true) {
            //       next()
            //     } else {
            //       next({ name: 'form-daily-drilling-report' })
            //       NProgress.done()
            //     }
            //   }
            // }else {
            //   // Continue to the login page
            //   next()
            // }
          } else {
            if (process.env.NODE_ENV  !== 'production') console.log("User has no requested privilege")
            next({ name: '404' })
          }
        } else {
          redirectToLogin()
        }
      })
      .catch((e) => {
        console.log(e)
        if (
          store.getters['auth/hasPriv'](routeTo.meta.priv) ||
          typeof routeTo.meta.priv === 'undefined'
        ) {
          next()
        } else {
          if (process.env.NODE_ENV  !== 'production') console.log("User validation failed")
          next({ name: '404' })
        }
      })
  }

  // If auth is required and the user is NOT currently logged in,
  // redirect to login.
  redirectToLogin()

  function redirectToLogin() {
    window.localStorage.clear()
    // Pass the original route to the login component
    next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
  }
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              if (routeFrom.name === args[0].name) {
                // Complete the animation of the route progress bar.
                NProgress.done()
              }
              // Complete the redirect.
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          // Otherwise, continue resolving the route.
          resolve()
        }
      })
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return
  }

  // If we reach this point, continue resolving the route.
  next()
})

// When each route is finished evaluating...
router.afterEach((routeTo, routeFrom) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
  setTimeout(function() {
    document.body.style.overflowY = 'auto'
  }, 600)
  const pathList = [
    '/ui/notifications',
    '/comparison-study',
    '/account',
    '/account/create',
    '/account/detail',
    '/',
  ]
  const path = routeTo.path.split('/')
  let routeToPath = ''
  if (path.length > 3) {
    routeToPath = routeTo.path.split('/')[0] + '/' + routeTo.path.split('/')[1]
  } else {
    routeToPath = routeTo.path
  }
  if (pathList.includes(routeToPath)) {
    store.dispatch('auth/setWell', null)
  }
})

export default router
